var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeakerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2501 4.4115V14.43C8.24988 14.7408 8.13996 15.0417 7.93971 15.2794C7.73946 15.5172 7.46172 15.6766 7.15543 15.7297C6.84914 15.7827 6.53396 15.726 6.26539 15.5695C5.99683 15.4129 5.79213 15.1667 5.68735 14.874L4.0771 10.2615M13.5001 9.75C14.0968 9.75 14.6691 9.51295 15.0911 9.09099C15.513 8.66903 15.7501 8.09674 15.7501 7.5C15.7501 6.90326 15.513 6.33097 15.0911 5.90901C14.6691 5.48705 14.0968 5.25 13.5001 5.25M4.0771 10.2622C3.44051 9.99158 2.91699 9.50929 2.59512 8.897C2.27325 8.2847 2.17281 7.58001 2.3108 6.90217C2.44878 6.22434 2.81672 5.61499 3.35234 5.17725C3.88795 4.73951 4.55836 4.50026 5.2501 4.5H6.6241C9.6991 4.5 12.3428 3.5745 13.5001 2.25V12.75C12.3428 11.4255 9.69985 10.5 6.6241 10.5H5.2501C4.84707 10.5006 4.44809 10.4197 4.0771 10.2622V10.2622Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerIcon);
export default __webpack_public_path__ + "static/media/speaker_icon.fffb16cd7e5f4d763b522d2d877df3cd.svg";
export { ForwardRef as ReactComponent };